// Phase 4A env accessors.
// Throws ConfigError at call time (not module-load) so a missing var doesn't
// take down unrelated pages.

export class ConfigError extends Error {
  constructor(public code: string, message: string) {
    super(message);
    this.name = "ConfigError";
  }
}

// Pinned in docs/phase4a.md. Hard-coded so the audited branch is greppable
// from source.
const PINNED_BRANCH_ID = "agtbrch_2101ks81h3awf2pswssve1dxv8q8";
const PINNED_AGENT_ID = "oikQrCEuNKKkiWlD7b0B";

export function getAgentId(): string {
  const v = import.meta.env.VITE_ELEVENLABS_AGENT_ID as string | undefined;
  return v || PINNED_AGENT_ID;
}

export function getAgentBranchId(): string {
  const raw = import.meta.env.VITE_ELEVENLABS_AGENT_BRANCH_ID as
    | string
    | undefined;

  // Missing env var -> fall back to the pinned branch in all environments.
  // The branch is hard-coded above, so a missing VITE var is not a real
  // configuration gap; only an explicit mismatch is.
  if (!raw) return PINNED_BRANCH_ID;


  if (raw !== PINNED_BRANCH_ID) {
    throw new ConfigError(
      "branch_id_mismatch",
      `VITE_ELEVENLABS_AGENT_BRANCH_ID (${raw}) does not match the pinned Phase 4A hash (${PINNED_BRANCH_ID}).`,
    );
  }
  return raw;
}
